import { Dispatch } from 'redux';
import { StoreState } from '../store-interfaces';
import { permissionsHandler, ResponseOrError } from './common-handler';
import { getErrorJson } from '@mm/utils';
import { UNPROCESSABLE_ENTITY } from '@mm/constants/status-codes';
import { unbusyAll } from '../actions/commonActions';
import CrudActionContainer from '../actions/CrudActionContainer';

export const adConfigsHandler =
  (dispatch: Dispatch<StoreState>, container: CrudActionContainer) =>
  async (error: ResponseOrError) => {
    if (error instanceof Response) {
      const responseErrorBody = await getErrorJson(error);
      if (error.status === UNPROCESSABLE_ENTITY && responseErrorBody.errors) {
        dispatch(unbusyAll());
        return responseErrorBody.errors;
      }
    }
    return permissionsHandler(dispatch, container)(error);
  };
